/**
 * VyV Conseil MRH Public API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpUrlEncodingCodec, HttpErrorResponse } from '@angular/common/http';

import { catchError, Observable, throwError } from 'rxjs';

import { VyVContextId } from '../models/vyVContextId';
import { VyVESHGetAdressesResponse } from '../models/vyVESHGetAdressesResponse';
import { VyVESHGetBailleursResponse } from '../models/vyVESHGetBailleursResponse';
import { VyVESHGetCodesPostauxResponse } from '../models/vyVESHGetCodesPostauxResponse';
import { VyVESHGetVillesResponse } from '../models/vyVESHGetVillesResponse';
import { VyVSharedCodePostal } from '../models/vyVSharedCodePostal';
import { VyVSharedNomBailleur } from '../models/vyVSharedNomBailleur';
import { VyVSharedProblemDetails } from '../models/vyVSharedProblemDetails';
import { VyVSharedVille } from '../models/vyVSharedVille';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { ApiError } from '../error';
import { AppConfig } from 'src/app/app.config';

@Injectable()
export class RefEshService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders({
    'x-brand': this.appConfig.getConfig('brand')
  });
  public configuration = new Configuration();

  constructor(
    @Inject(AppConfig) private appConfig: AppConfig,
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   * Get ESH addresses by lessor, zip code and city
   * @param bailleur
   * @param codePostal
   * @param ville
   * @param context
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAdresses(
    bailleur: VyVSharedNomBailleur,
    codePostal: VyVSharedCodePostal,
    ville: VyVSharedVille,
    context: VyVContextId,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VyVESHGetAdressesResponse>;
  public getAdresses(
    bailleur: VyVSharedNomBailleur,
    codePostal: VyVSharedCodePostal,
    ville: VyVSharedVille,
    context: VyVContextId,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VyVESHGetAdressesResponse>>;
  public getAdresses(
    bailleur: VyVSharedNomBailleur,
    codePostal: VyVSharedCodePostal,
    ville: VyVSharedVille,
    context: VyVContextId,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VyVESHGetAdressesResponse>>;
  public getAdresses(
    bailleur: VyVSharedNomBailleur,
    codePostal: VyVSharedCodePostal,
    ville: VyVSharedVille,
    context: VyVContextId,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (bailleur === null || bailleur === undefined) {
      throw new Error(
        'Required parameter bailleur was null or undefined when calling getAdresses.'
      );
    }

    if (codePostal === null || codePostal === undefined) {
      throw new Error(
        'Required parameter codePostal was null or undefined when calling getAdresses.'
      );
    }

    if (ville === null || ville === undefined) {
      throw new Error('Required parameter ville was null or undefined when calling getAdresses.');
    }

    if (context === null || context === undefined) {
      throw new Error('Required parameter context was null or undefined when calling getAdresses.');
    }

    let queryParameters = new HttpParams({ encoder: new HttpUrlEncodingCodec() });
    if (bailleur !== undefined && bailleur !== null) {
      queryParameters = queryParameters.set('bailleur', <any>bailleur);
    }
    if (codePostal !== undefined && codePostal !== null) {
      queryParameters = queryParameters.set('codePostal', <any>codePostal);
    }
    if (ville !== undefined && ville !== null) {
      queryParameters = queryParameters.set('ville', <any>ville);
    }
    if (context !== undefined && context !== null) {
      queryParameters = queryParameters.set('context', <any>context);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json', 'application/problem+json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const path = `${this.basePath}/api/esh/adresses`;
    return this.httpClient
      .request<VyVESHGetAdressesResponse>('get', path, {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      })
      .pipe(catchError(error => this.handleApiError(path, error)));
  }

  /**
   *
   * Get all ESH lessors
   * @param context
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBailleurs(
    context: VyVContextId,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VyVESHGetBailleursResponse>;
  public getBailleurs(
    context: VyVContextId,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VyVESHGetBailleursResponse>>;
  public getBailleurs(
    context: VyVContextId,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VyVESHGetBailleursResponse>>;
  public getBailleurs(
    context: VyVContextId,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (context === null || context === undefined) {
      throw new Error(
        'Required parameter context was null or undefined when calling getBailleurs.'
      );
    }

    let queryParameters = new HttpParams({ encoder: new HttpUrlEncodingCodec() });
    if (context !== undefined && context !== null) {
      queryParameters = queryParameters.set('context', <any>context);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json', 'application/problem+json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const path = `${this.basePath}/api/esh/bailleurs`;
    return this.httpClient
      .request<VyVESHGetBailleursResponse>('get', path, {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      })
      .pipe(catchError(error => this.handleApiError(path, error)));
  }

  /**
   *
   * Get ESH zip codes by lessor
   * @param bailleur
   * @param context
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCodesPostaux(
    bailleur: VyVSharedNomBailleur,
    context: VyVContextId,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VyVESHGetCodesPostauxResponse>;
  public getCodesPostaux(
    bailleur: VyVSharedNomBailleur,
    context: VyVContextId,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VyVESHGetCodesPostauxResponse>>;
  public getCodesPostaux(
    bailleur: VyVSharedNomBailleur,
    context: VyVContextId,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VyVESHGetCodesPostauxResponse>>;
  public getCodesPostaux(
    bailleur: VyVSharedNomBailleur,
    context: VyVContextId,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (bailleur === null || bailleur === undefined) {
      throw new Error(
        'Required parameter bailleur was null or undefined when calling getCodesPostaux.'
      );
    }

    if (context === null || context === undefined) {
      throw new Error(
        'Required parameter context was null or undefined when calling getCodesPostaux.'
      );
    }

    let queryParameters = new HttpParams({ encoder: new HttpUrlEncodingCodec() });
    if (bailleur !== undefined && bailleur !== null) {
      queryParameters = queryParameters.set('bailleur', <any>bailleur);
    }
    if (context !== undefined && context !== null) {
      queryParameters = queryParameters.set('context', <any>context);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json', 'application/problem+json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const path = `${this.basePath}/api/esh/codesPostaux`;
    return this.httpClient
      .request<VyVESHGetCodesPostauxResponse>('get', path, {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      })
      .pipe(catchError(error => this.handleApiError(path, error)));
  }

  /**
   *
   * Get ESH cities by lessor and zip code
   * @param bailleur
   * @param codePostal
   * @param context
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getVilles(
    bailleur: VyVSharedNomBailleur,
    codePostal: VyVSharedCodePostal,
    context: VyVContextId,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VyVESHGetVillesResponse>;
  public getVilles(
    bailleur: VyVSharedNomBailleur,
    codePostal: VyVSharedCodePostal,
    context: VyVContextId,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VyVESHGetVillesResponse>>;
  public getVilles(
    bailleur: VyVSharedNomBailleur,
    codePostal: VyVSharedCodePostal,
    context: VyVContextId,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VyVESHGetVillesResponse>>;
  public getVilles(
    bailleur: VyVSharedNomBailleur,
    codePostal: VyVSharedCodePostal,
    context: VyVContextId,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (bailleur === null || bailleur === undefined) {
      throw new Error('Required parameter bailleur was null or undefined when calling getVilles.');
    }

    if (codePostal === null || codePostal === undefined) {
      throw new Error(
        'Required parameter codePostal was null or undefined when calling getVilles.'
      );
    }

    if (context === null || context === undefined) {
      throw new Error('Required parameter context was null or undefined when calling getVilles.');
    }

    let queryParameters = new HttpParams({ encoder: new HttpUrlEncodingCodec() });
    if (bailleur !== undefined && bailleur !== null) {
      queryParameters = queryParameters.set('bailleur', <any>bailleur);
    }
    if (codePostal !== undefined && codePostal !== null) {
      queryParameters = queryParameters.set('codePostal', <any>codePostal);
    }
    if (context !== undefined && context !== null) {
      queryParameters = queryParameters.set('context', <any>context);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json', 'application/problem+json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const path = `${this.basePath}/api/esh/villes`;
    return this.httpClient
      .request<VyVESHGetVillesResponse>('get', path, {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      })
      .pipe(catchError(error => this.handleApiError(path, error)));
  }

  private handleApiError(path: string, error: HttpErrorResponse) {
    let message: string;
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      message = 'A client side error occurred: ' + error.error;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      message = 'A server side error occurred: ' + error.status;
    }

    return throwError(() => new ApiError(message, path, error));
  }
}
